import React, { useState } from "react";
import { BulbOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import WalletBackground from "../components/WalletBackground";
import BaitLogo from "../BaitLogo.png";

import "../components/Header.css";

const { TextArea } = Input;

function RecoverAccount({ setWallet, setSeedPhrase }) {
  const navigate = useNavigate();
  const [typedSeed, setTypedSeed] = useState("");
  const [nonValid, setNonValid] = useState(false);

  function seedAdjust(e) {
    setNonValid(false);
    setTypedSeed(e.target.value);
  }

  function recoverWallet() {
    let recoveredWallet;
    try {
      recoveredWallet = ethers.Wallet.fromPhrase(typedSeed);
    } catch (err) {
      setNonValid(true);
      return;
    }

    localStorage.setItem("seedPhrase", typedSeed);
    localStorage.setItem("privateKey", recoveredWallet.privateKey);
    localStorage.setItem("address", recoveredWallet.address);

    setSeedPhrase(typedSeed);
    setWallet(recoveredWallet.address);
    navigate("/yourwallet");
  }

  return (
    <div className="content">
      {/* ==================== HEADER (bigger logo + text) ==================== */}
      <div
        className="wallet-header-brand"
        style={{
          marginBottom: "28px",
          gap: "20px",
          maxWidth: "100%",
        }}
      >
        <div
          className="brand-coin-wrap"
          style={{
            width: "96px",
            height: "96px",
            minWidth: "96px",
            minHeight: "96px",
          }}
        >
          <div className="brand-coin-glow" aria-hidden="true" />
          <img
            src={BaitLogo}
            alt="BAIT PAY"
            className="brand-coin"
            style={{
              width: "96px",
              height: "96px",
            }}
          />
        </div>

        <div className="brand-text">
          <span
            className="brand-title"
            style={{
              fontSize: "38px",
              letterSpacing: "2.2px",
              lineHeight: 1.05,
            }}
          >
            BAIT PAY
          </span>
          <span
            className="brand-tagline"
            style={{
              fontSize: "13px",
              letterSpacing: "4.5px",
              marginTop: "4px",
            }}
          >
            DIGITAL GOLD
          </span>
        </div>
      </div>

      <div className="mnemonic">
        <BulbOutlined style={{ fontSize: "20px" }} />
        <WalletBackground />
        <div>
          Type your seed phrase in the field below to recover your wallet (it
          should include 12 words separated with spaces)
        </div>
      </div>

      <div className="seedPhraseContainer">
        <textarea
          value={typedSeed}
          onChange={seedAdjust}
          rows={4}
          spellCheck={false}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder="Type your 12-word seed phrase here..."
          className="recover-seed-input"
        />
      </div>

      <Button
        disabled={
          typedSeed.split(" ").length !== 12 || typedSeed.slice(-1) === " "
        }
        className="frontPageButton"
        type="primary"
        onClick={recoverWallet}
      >
        Recover Wallet
      </Button>

      {nonValid && <p style={{ color: "red" }}>Invalid Seed Phrase</p>}

      <p className="frontPageBottom" onClick={() => navigate("/")}>
        <span>Back Home</span>
      </p>
    </div>
  );
}

export default RecoverAccount;